import { render, staticRenderFns } from "./live-list-detail.vue?vue&type=template&id=636fcd85&"
import script from "./live-list-detail.vue?vue&type=script&lang=js&"
export * from "./live-list-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports